<script setup lang="ts">
import { useSidebarStore } from '~~/src/stores/sidebar'
import { useLeftSidebarStore } from '~~/src/stores/leftSidebar'

const sidebarStore = useSidebarStore()
const sidebarRight = sidebarStore.state
const { toggleSidebar } = sidebarStore

const sidebarLeftStore = useLeftSidebarStore()
const toggleSidebarLeft = sidebarLeftStore.toggleSidebar

const route = useRoute()
const router = useRouter()
const user = useUser()

const handlerOpenSidebar = () => {
  if (!user.value)
    return router.push(useGetLoginURL())

  toggleSidebar()
}

const handlerOpenSidebarLeft = () => {
  if (sidebarRight.isOpen)
    toggleSidebar()

  toggleSidebarLeft()
}

const handlerCloseSidebars = () => {
  if (sidebarRight.isOpen)
    toggleSidebar()

  if (sidebarLeftStore.isOpen)
    toggleSidebarLeft()
}

const activeItemKey = computed(() => {
  if (sidebarRight.isOpen)
    return 'sidebar'
  if (sidebarLeftStore.isOpen)
    return 'sidebar-left'
  if (route.fullPath.includes('automations'))
    return 'automations'
  if (route.fullPath.includes('create'))
    return 'create'
  if (route.fullPath === '/')
    return 'discovery'
  return ''
})
</script>

<template>
  <div
    class="w-full md:hidden bg-white flex text-darkGray border-t-softGray border-t-1"
    aria-label="Create a Prompt"
  >
    <NuxtLink
      to="/automations"
      flex items-center justify-center self-stretch w-full p-4
      text-soft-black
      @click="handlerCloseSidebars"
    >
      <IconMenuAutomatationFilled v-if="(activeItemKey === 'automations')" class="h-[20px] w-[17px]" />
      <IconMenuAutomatation v-else class="h-[20px] w-[17px]" />
    </NuxtLink>

    <NuxtLink
      to="/"
      flex items-center justify-center self-stretch w-full p-4
      text-soft-black
      @click="handlerCloseSidebars"
    >
      <IconDiscoveryFilled v-if="(activeItemKey === 'discovery')" class="w-[24px] h-auto" />
      <IconDiscovery v-else class="w-[24px] h-auto" />
    </NuxtLink>

    <NuxtLink
      to="/prompt/create"
      flex
      items-center justify-center self-stretch w-full p-4 text-soft-black
      @click="handlerCloseSidebars"
    >
      <div v-if="activeItemKey === 'create'" i-mdi:plus-circle class="w-6 h-6" />
      <div v-else i-mdi:plus-circle-outline class="w-6 h-6" />
    </NuxtLink>

    <ClientOnly>
      <button
        v-if="user"
        flex
        items-center
        justify-center
        self-stretch
        w-full
        p-4
        text-soft-black
        aria-label="Open Drawer"
        @click="handlerOpenSidebar()"
      >
        <IconMenuSavesFilled v-if="(activeItemKey === 'sidebar')" class="w-[18px] h-auto" />
        <IconMenuSaves v-else class="w-[18px] h-auto" />
      </button>
    </ClientOnly>

    <button
      flex
      items-center
      justify-center
      self-stretch
      w-full
      p-4
      text-soft-black
      aria-label="Open Drawer"
      @click="handlerOpenSidebarLeft()"
    >
      <IconMenuBarsFilled v-if="(activeItemKey === 'sidebar-left')" class="w-[17px] h-[14px]" />
      <IconMenuBars v-else class="w-[17px] h-[14px]" />
    </button>
  </div>
</template>
